import { render, staticRenderFns } from "./TabPutAway.vue?vue&type=template&id=d3055c58"
import script from "./TabPutAway.vue?vue&type=script&lang=js"
export * from "./TabPutAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports